import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export default function SichtbarkeitPlanen() {
  return <section data-section-id="52547" id="einladung-zum-dialog" className="bg-background text-foreground w-full py-24 md:py-32 overflow-hidden relative bg-[radial-gradient(circle_at_center,_var(--color-secondary)_0%,transparent_70%)]">
      {}
      <style>{`
        @keyframes weightless-float {
          0%, 100% { transform: translateY(0); animation-timing-function: ease-in-out; }
          50% { transform: translateY(-15px); animation-timing-function: ease-in-out; }
        }
        .animate-weightless {
          animation: weightless-float 8s infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-8 text-center max-w-5xl">
        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-primary mb-6 leading-tight tracking-tight">
          Beginne deine Reise zu dir selbst.
        </h2>
        
        <p className="font-sans text-lg md:text-2xl text-foreground/80 mb-12 max-w-3xl mx-auto font-normal">
          Finde emotionale Klarheit und innere Ruhe in einem geschützten Raum. Ich begleite dich achtsam auf deinem Weg der persönlichen Transformation und ganzheitlichen Heilung.
        </p>

        <div className="flex justify-center">
          <Link to="/ContactPage">
            <Button size="lg" className={cn("bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground", "text-lg md:text-xl font-medium py-8 px-10 h-auto rounded-sm shadow-sm", "animate-weightless transition-all hover:scale-105")}>
              Gespräch vereinbaren
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}